export const menu = [
    {
        name: 'Home',
        routeName: 'Home',
        icon: 'home',
        child: []
    },
    {
        name: 'Dashboard',
        routeName: 'Dashboard',
        icon: 'grid',
        child: []
    },
    {
        name: 'Other',
        routeName: '',
        icon: 'align-left',
        child: [
            {
                name: 'Email',
                routeName: 'Email',
                icon: 'email'
            },
            {
                name: 'Category',
                routeName: '',
                icon: 'align-grid'
            }
        ]
    },
]